import qs from 'qs';
import { each, isEmpty } from 'lodash-es';

const allowedParams = ['country_iso', 'store'];

const usePathFilters = (filters = {}, paramsWhitelist = allowedParams) => {
  const pathWithFilters = (baseUrl, additionalParams = {}) => {
    const searchParams = new URLSearchParams();

    each(
      paramsWhitelist,
      (paramName) => filters[paramName] && searchParams.set(paramName, filters[paramName])
    );

    const pathname = baseUrl[-1] === '?' ? baseUrl : `${baseUrl}?`;
    return `${pathname}${searchParams.toString()}${
      isEmpty(additionalParams) ? '' : `&${qs.stringify(additionalParams)}`
    }`;
  };

  return pathWithFilters;
};

export default usePathFilters;

export const updatePath = (baseUrl, paramsWhitelist = allowedParams) => {
  const currentSearchParams = new URLSearchParams(window.location.search);
  const resultSearchParams = new URLSearchParams();

  each(paramsWhitelist, (paramName) => {
    const paramValue = currentSearchParams.get(paramName);
    return paramValue && resultSearchParams.set(paramName, paramValue);
  });
  const resultSearchParamsStr = resultSearchParams.toString()
    ? `?${resultSearchParams.toString()}`
    : '';

  return `${baseUrl}${resultSearchParamsStr}`;
};

export const updateCurrentPath = (
  filters,
  paramsWhitelist = allowedParams,
  baseUrl = window.location.pathname
) => {
  const searchParams = new URLSearchParams(window.location.search);

  each(
    paramsWhitelist,
    (paramName) => filters[paramName] && searchParams.set(paramName, filters[paramName])
  );

  const newPath = baseUrl[-1] === '?' ? baseUrl : `${baseUrl}?`;
  window.history.replaceState(null, '', newPath + searchParams.toString());
};

export const pathFilterValue = (filter) => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(filter);
};
